import { createFocusTrap, FocusTrap } from 'focus-trap';
import { on } from 'delegated-events';
import { Instance } from '@popperjs/core';
import invisibleFocus from '../../../javascripts/utils/invisibleFocus';
import createPopper from '../../../javascripts/utils/createPopper';

let focusTrap: FocusTrap;
let popper: Instance;

on('click', '.filter__button', (event) => {
  const { currentTarget: $button } = event;
  const $children =
    $button.parentNode?.querySelector<HTMLElement>('.filter__children');

  if ($button.parentNode instanceof HTMLElement && $children) {
    event.preventDefault();

    if (!$children.hidden) {
      focusTrap?.deactivate();
    } else {
      $children.hidden = false;

      popper = createPopper($button, $children, {
        placement: 'bottom',
        strategy: 'fixed',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 20],
            },
          },
        ],
      });

      focusTrap = createFocusTrap($button.parentNode, {
        onDeactivate() {
          $children.hidden = true;
          popper?.destroy();
          invisibleFocus($button);
          $button.classList.remove('button--active');
          $button.ariaExpanded = 'false';
        },
        initialFocus: '.filter__children',
        clickOutsideDeactivates: true,
        returnFocusOnDeactivate: false,
        preventScroll: false,
      });

      $button.classList.add('button--active');
      $button.ariaExpanded = 'true';
      focusTrap.activate();
    }
  }
});

on('click', '.filter__child-link', (event) => {
  if (!event.target || !(event.target instanceof HTMLElement)) return;

  const target = event.target.closest('.filter__child-link');

  if (!target) return;

  const filterItem = target.closest('.filter__item');

  const options = filterItem?.querySelectorAll<HTMLElement>(
    '.filter__child-link',
  );

  if (!options) return;

  focusTrap.deactivate();

  const button = filterItem?.querySelector<HTMLElement>('.button');
  const textLabel = filterItem?.querySelector<HTMLElement>(
    `[data-group-text-label]`,
  );

  // eslint-disable-next-line no-restricted-syntax
  for (const option of options)
    if (option.isEqualNode(target)) {
      option.dispatchEvent(
        new CustomEvent(`filter-${option.dataset.group}`, {
          detail: option.dataset.value,
          bubbles: true,
          cancelable: true,
        }),
      );

      if (!(textLabel && button)) return;

      if (option.dataset.value) {
        option.dataset.selected = '';
        textLabel.textContent = option.textContent;
        button.classList.add('button--dropdown-selected');
        button.ariaLabel = `${
          textLabel.dataset.defaultText
        }: ${option.textContent?.trim()}`;
      } else {
        textLabel.textContent =
          textLabel.dataset.defaultText || option.textContent;
        button.classList.remove('button--dropdown-selected');
        button.ariaLabel =
          textLabel.dataset.defaultText ||
          `${textLabel.dataset.defaultText}: ${option.textContent?.trim()}`;
      }
    } else {
      delete option.dataset.selected;
    }

  const siblingFilterItems = Array.from(
    filterItem?.parentNode?.children || [],
  ).filter((node) => !node.isEqualNode(filterItem));

  const siblingFilterItemOptions = siblingFilterItems
    .map((siblingFilterItem) =>
      Array.from(
        siblingFilterItem.querySelectorAll<HTMLElement>('.filter__child-link'),
      ),
    )
    .flat();

  // eslint-disable-next-line no-restricted-syntax
  for (const siblingFilterItem of siblingFilterItems) {
    const siblingFilterItemButton =
      siblingFilterItem.querySelector<HTMLElement>('.button');
    const siblingFilterItemTextLabel =
      siblingFilterItem.querySelector<HTMLElement>(`[data-group-text-label]`);

    if (!(siblingFilterItemTextLabel && siblingFilterItemButton)) return;

    siblingFilterItemTextLabel.textContent =
      siblingFilterItemTextLabel.dataset.defaultText || '';
    siblingFilterItemButton.classList.remove('button--dropdown-selected');
    siblingFilterItemButton.ariaLabel =
      siblingFilterItemTextLabel.dataset.defaultText || '';
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const option of siblingFilterItemOptions) {
    delete option.dataset.selected;
  }
});
